'use client';

import React from 'react';
import { useBundler } from '@app/components/bundler/bundler-provider/bundler-provider';
import styles from './BundlerHeader.module.css';

const BundlerHeader = () => {
    const { bundle, setBundle, bundleDefinition } = useBundler();

    if (!bundle) return null;

    const { title, handle } = bundle;

    const isSelected = (bundleHandle) => bundleHandle === handle;

    return (
        <div className={styles.bundlerHeader}>
            <h1 className={styles.bundlerHeading}>{`${title}:`}</h1>
            {bundleDefinition.map((iteratorBundle) => {
                const { variant, handle: bundleIteratorHandle } =
                    iteratorBundle;
                return (
                    <div
                        className={styles.bundlerVariant}
                        data-selected={isSelected(bundleIteratorHandle)}
                        onClick={() => setBundle(iteratorBundle)}
                        key={`bundle_${variant}_${handle}`}
                        type="button"
                    >
                        {variant}
                    </div>
                );
            })}
        </div>
    );
};

export default BundlerHeader;
